<template>
  <div class="doclist">
    <ul>
      <li v-for="item in data" :key="item.id" @click="go_register(item)">
        <div class="doc_img">
          <img v-if="item.logo" :src="item.logo | imgFilter" alt="" />
          <img v-else src="/static/img/ask/doctoricon.png" alt="" />
          <!--<span>从业三十年</span>-->
        </div>
        <div class="doc_info">
          <div>
            <b>{{ item.doctor_name }}</b>
            <span>{{ item.level ? (item.level.length > 5 ? item.level.substring(0, 5) + '...' : item.level) : '' }}</span>
          </div>
          <p>擅长:{{ item.speciality }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['type', 'data'],
  methods: {
    go_register(item) {
      this.$router.push(
        `/registration_doctor_detail_new?hos_code=${item.hospital_code}&department_id=${item.department_id}&doctorId=${item.doctor_id}&hospital_area_id=${item.hospital_area_id}&hospital_id=${item.hospital_id}`
      )
    }
  }
}
</script>

<style scoped lang="less">
.doclist {
  width: 100%;
  ul {
    width: 90%;
    margin: 0 5%;
    li {
      width: 100%;
      margin: 0.5rem 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      box-shadow: 0px 8px 20px 0px rgba(207, 217, 173, 0.2);
      border-radius: 0.25rem;
      padding: 0.25rem;
      box-sizing: border-box;
      border: 1px solid #e6f2c2;
      .doc_img {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        img {
          display: block;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          margin: 0.15rem;
        }
        span {
          display: inline-block;
          font-size: 0.3rem;
          color: #b8cc7a;
        }
      }
      .doc_info {
        width: 75%;
        div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          b {
            font-size: 0.4rem;
          }
          span {
            background: #b3cc66;
            color: #fff;
            margin: 0.15rem 0;
            border-radius: 0.25rem;
            padding: 0 0.15rem;
            font-size: 0.35rem;
            margin-left: 0.5rem;
          }
        }
        > span {
          display: inline-block;
          font-size: 0.37rem;
          margin: 0.15rem 0;
        }
        p {
          font-size: 0.35rem;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          color: #999;
        }
      }
    }
  }
}
</style>
